import { render, staticRenderFns } from "./collectionFrequencyUP.vue?vue&type=template&id=7452a230&scoped=true&"
import script from "./collectionFrequencyUP.vue?vue&type=script&lang=js&"
export * from "./collectionFrequencyUP.vue?vue&type=script&lang=js&"
import style0 from "./collectionFrequencyUP.vue?vue&type=style&index=0&id=7452a230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7452a230",
  null
  
)

export default component.exports